import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../../_common/TextContent';
import '../EquipmentProfile.scss';

interface EquipmentDestinationDetailsProps {
    destinationType?: string | null;
    destinationJob?: string | null;
    destinationLofa?: string | null;
    destinationYard?: string | null;
    destinationLongitude?: number | null;
    destinationLatitude?: number | null;
    destinationRegion?: string | null;
    destinationDistrict?: string | null;
}

const EquipmentDestinationDetails = ({
    destinationType,
    destinationJob,
    destinationLofa,
    destinationYard,
    destinationLongitude,
    destinationLatitude,
    destinationRegion,
    destinationDistrict,
}: EquipmentDestinationDetailsProps): React.ReactElement => {
    return (
        <Col>
            <Row className="EquipmentsDetails-Title">Destination Details</Row>
            <Row>
                <TextContent hasTopMargin title={'Destination Type: '} value={destinationType || ''} />
            </Row>
            {destinationType === 'Job' && (
                <Row>
                    <TextContent hasTopMargin title={'Destination: '} value={destinationJob || ''} />
                </Row>
            )}
            {destinationType === 'Lofa' && (
                <Row>
                    <TextContent hasTopMargin title={'Destination Lofa: '} value={destinationLofa || ''} />
                </Row>
            )}
            {destinationType === 'Yard' && (
                <Row>
                    <TextContent hasTopMargin title={'Destination Yard: '} value={destinationYard || ''} />
                </Row>
            )}
            {destinationType === 'Other' && (
                <>
                    <Row>
                        <TextContent hasTopMargin title={'Destination Longitude: '} value={destinationLongitude?.toString() || ''} />
                    </Row>
                    <Row>
                        <TextContent hasTopMargin title={'Destination Latitude: '} value={destinationLatitude?.toString() || ''} />
                    </Row>
                </>
            )}
            <Row>
                <TextContent hasTopMargin title={'Destination Region: '} value={destinationRegion || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Destination District: '} value={destinationDistrict || ''} />
            </Row>
        </Col>
    );
};

export default EquipmentDestinationDetails;
